export const DEFAULT_HOUR = '06';
export const DEFAULT_MINUTE = '00';
export const HOURS = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
export const MINUTE_SLOTS = ['00', '15', '30', '45'];
